// extracted by mini-css-extract-plugin
export default {"mapCanvas":"GoalMap_mapCanvas__fJ78P"};